import { Loader } from '@mantine/core'
import { motion } from 'motion/react'
import { Suspense, useContext } from 'react'
import Footer from '@/components/ui/Footer'
import { FeatureFlagContext } from '@/contexts/FeatureFlagsContext'
import useSSR from '@/hooks/use-ssr'
import { CartModule } from '@/modules/Cart'
import StoreNavigation from '@/modules/shared/StoreNavigation/StoreNavigation'
import { fadeIn } from '@/utils/animations'
import DefaultTemplate, { TemplateProps } from './Default.template'


const StoreTemplate = ({ children, ...props }: TemplateProps) => {
    const isSSR = useSSR()

    const { isFeatureEnabled } = useContext(FeatureFlagContext)

    if (isSSR) {
        return (
            <motion.div
                {...fadeIn}
                className="flex items-center justify-center h-screen bg-[var(--btn-hover)]"
            >
                <Loader size={24} color="green.1" variant="oval" />
            </motion.div>
        )
    }

    return (
        <DefaultTemplate className="flex flex-col w-full h-full" {...props}>
            {isFeatureEnabled('cart') && (
                <Suspense>
                    <CartModule />
                </Suspense>
            )}
            <StoreNavigation />
 
            <main role="main" className="p-4 relative flex-1">
                {children}
            </main>
            <Footer />
        </DefaultTemplate>
    )
}

export default StoreTemplate
